import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import GroupSelect from '../../groups/select/GroupSelect'
import Select from '../../../packages/kiti/components/form/Select'
import UserSelect from './UserSelect'
import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'

const UsersOrGroupsSelect = ({ assign, interpolations, ...props }) => {
  if (assign.id === 'TO_GROUP') {
    return <GroupSelect multiple assign={assign} {...props} />
  }

  return <UserSelect interpolations={interpolations} assign={assign} {...props} />
}

/**
 * `automaticPath`/`userOrGroupPath` (opcionais) permitem usar a opção "Automático" em formulários onde
 * o responsável e o flag `automatic` NÃO ficam na raiz do form (ex.: payload de uma automação). Sem eles,
 * o comportamento é o de sempre (`userOrGroup`/`automatic` na raiz). `automatic` indica o estado inicial.
 */
const Wrapper = ({
  interpolations = [],
  showAutomaticOption = false,
  automatic = false,
  automaticPath,
  userOrGroupPath,
  ...props
}) => {
  const { t } = useTranslation('common')
  const { handleChange, handleChangeIn } = useFormState()

  const setUserOrGroup = value =>
    userOrGroupPath ? handleChangeIn(userOrGroupPath, value) : handleChange('userOrGroup', value)
  const setAutomatic = value =>
    automaticPath ? handleChangeIn(automaticPath, value) : handleChange('automatic', value)

  const ASSIGN_OPTIONS = [
    { name: t('user'), id: 'TO_USER', entityType: 'User' },
    { name: t('group'), id: 'TO_GROUP', entityType: 'UserGroup' }
  ]
  const AUTOMATIC_OPTION = { name: t('automatic'), id: 'AUTOMATIC' }

  const typename = props.value?.__typename
  const options = showAutomaticOption ? ASSIGN_OPTIONS.concat(AUTOMATIC_OPTION) : ASSIGN_OPTIONS

  const initialAssign =
    automatic && showAutomaticOption
      ? AUTOMATIC_OPTION
      : typename === 'UserGroup' || Array.isArray(props.value)
        ? options[1]
        : options[0]
  const [assign, setAssign] = useState(initialAssign)

  const hangleChange = value => {
    setAssign(value)

    if (value.id === 'AUTOMATIC') {
      setUserOrGroup(null)
      if (showAutomaticOption) {
        setAutomatic(true)
      }
    } else {
      if (showAutomaticOption) {
        setAutomatic(false)
      }
    }
  }

  React.useEffect(() => {
    if (assign.id === 'TO_GROUP' && !Array.isArray(props.value)) props.onChange([])
  }, [assign])

  return (
    <Grid gutter={0.3}>
      <Col flex={1}>
        <Select onChange={hangleChange} value={assign} options={options} disabled={props.disabled} disableEmptyOption />
      </Col>

      <Col flex={2}>
        <UsersOrGroupsSelect
          {...props}
          assign={assign}
          interpolations={interpolations}
          disabled={assign?.id === 'AUTOMATIC'}
        />
      </Col>
    </Grid>
  )
}

export default Wrapper
